module.exports = __webpack_public_path__ + "img/small-logo.e0de7ab3.svg";